import React, { useEffect, useRef } from "react";
import { drawGridLines } from "./drawGridLines";
import { fillObjects } from "./fillObjects";
import { timerFired } from "./timerFired";
import info from "../data/info";
import PlayPauseButton from "./PlayPauseButton";
import ModelGridSize from "./ModelGridSize";
import '../styles/Board.css'
import { Link, useLocation } from 'react-router-dom';
import { useState } from "react";
import DataModeButtons from "./DataModeButtons";
import RefreshButton from "./RefreshButton";
import SettingsButton from "./SettingsButton";
import HowToPlay from "./HowToPlay";
import ThemeMode from "./ThemeMode";
import LoadMap from "./LoadMap";
import RemoveAgentsButton from "./RemoveAgentsButton";
import ReactGA from 'react-ga4';

//`const` is a signal that the identifier won't be reassigned. 
//`let` is a signal that the variable may be reassigned

// let canHandleEvents = false;

const math = require('mathjs'); //install using "npm install mathjs"
let DYNAMIC_TESTING = true
let GOALS = true
const output_path = "environments"

ReactGA.initialize('G-7HQ6K7SGK5'); //primal nus latest -GA

let dirDict = { 0: (0, 0), 1: (0, 1), 2: (1, 0), 3: (0, -1), 4: (-1, 0), 5: (1, 1), 6: (1, -1), 7: (-1, -1), 8: (-1, 1) }

export let { data } = info;

export default function Board() {
    const canvasRef = useRef(null);
    const location = useLocation();
    const path = location.pathname;

    const [WidthHeight, setWidthHeight] = useState({ width: 0, height: 0 });

  useEffect(() => {
    function updateCanvasSize() {
      const canvas = canvasRef.current;
      let width = window.innerWidth * 0.80; // set canvas width to 80% of screen width
      let height = window.innerWidth * 0.80; // set canvas height to 80% of screen height
      let max_width_height = 450;
      if(window.innerWidth<1000) {
        width = window.innerWidth * 0.9;
        height = window.innerWidth * 0.9;
      }
      if( width > max_width_height) {
        width = max_width_height;
        height = max_width_height;
      }
      
      canvas.width = width;
      canvas.height = height;
      data.width = width;
      data.height= height;
      setWidthHeight({ width, height });
    }

    window.addEventListener("resize", updateCanvasSize);
    updateCanvasSize();

    return () => window.removeEventListener("resize", updateCanvasSize);
  }, []);

    // only can detect change in props when use useState
    const [isPaused, setIsPaused] = useState(data.paused);
    const [modelStatus, setModelStatus] = useState(data.model_status);
    const [gridSize, setGridSize] = useState(data.size);
    const [theme, setTheme] = useState(data.theme);
    const [mapLoaded, setMapLoaded] = useState(data.map_loaded);

    const toggleTheme = () => {
        // console.log(`Theme is ${theme}`)
        let newTheme;
        ReactGA.event({
            category: 'Button',
            action: 'Click',
            label: 'Theme Mode Button is clicked'
          });
        if (theme == 'light') {
            newTheme = 'dark';
            ReactGA.event({
                category: 'Button',
                action: 'Click',
                label: 'Dark Theme Mode is selected'
              });

        } else {
            newTheme = 'light';
            ReactGA.event({
                category: 'Button',
                action: 'Click',
                label: 'Light Theme Mode is selected'
              });
        }
        // console.log(`New Theme Mode is : ${newTheme}`)
        setTheme(newTheme);
        data.theme = newTheme;
        // console.log(`theme is ${theme}`)
        // console.log(`data.theme is ${data.theme}`)
    }

    // Setting delay in eventlistener when page reloads

    // console.log('event listener blocked');
    // setTimeout(() => {
    //     console.log('event listener unblocked');
    //     // clickEvent();
    //     console.log("Clicked");
    //     keyDownEvent();
    // }, 500);

    useEffect(() => {
        document.addEventListener("click", clickEvent);
        return () => {
            document.removeEventListener("click", clickEvent);
        };
    }, []); // Run only once on mount

    useEffect(() => {
        document.addEventListener("keydown", keyDownEvent);
        return () => {
            document.removeEventListener("keydown", keyDownEvent);
        };
    }, []); // Run only once on mount



    useEffect(() => {

        const render = async () => {
            const canvas = canvasRef.current;
            const ctx = canvas.getContext("2d");

            // Set timer Delay, so it will run every data.timerDelay
            setTimeout(async () => {
                // Clears the rectangle
                ctx.clearRect(0, 0, canvas.width, canvas.height);
                // Filles the Goals, Agents and Obstacles
                fillObjects(data, ctx, canvas);
                // Draws the grid lines above the objects
                drawGridLines(data, ctx, canvas, data.theme);
                // TimerFired where ML is running here

                // Updates the data
                setIsPaused(data.paused)
                setModelStatus(data.model_status);
                setGridSize(data.size);
                setTheme(data.theme);
                setMapLoaded(data.map_loaded);

                if (!data.paused && data.model_uploaded) {
                    // console.log("timer")
                    await timerFired(data);
                }
                requestAnimationFrame(render);
            }, data.timerDelay);
        };
        render();
        setIsPaused(data.paused)
    }, []);

    return (
        <div class='board-container' style={{ textAlign: "center" }} data-theme={data.theme}>

            {/* <PrimalInstructions /> */}
            {/* <ModelStatus modelStatus={modelStatus} /> */}
            {/* <DataMode /> */}
            {/* <ModelGridSize gridSize={gridSize} /> */}
            {/* <ModelTimerDelay/> */}
            {/* <ModelSpeed /> */}
            {/* <ModelPlayPause isPaused={isPaused} /> */}
            {/* <ClearAll />
            <ClearAgents /> */}
            <br></br>
            {/* <UndoRedo/> */}
            {/* <h4 id="datas"></h4> */}

            <div className="controls-container">
                <DataModeButtons />
                <ModelGridSize gridSize={gridSize} />
                <PlayPauseButton isPaused={isPaused} modelStatus={modelStatus}/>
            </div>

            <div className="controls-container maploader-container">
                <LoadMap mapLoaded={mapLoaded} />
                
            </div>

            <canvas id="canvas" ref={canvasRef} width={data.width} height={data.height}></canvas>

            <div className="controls-container extra">
                {/* <SettingsButton toggleTheme={toggleTheme} /> */}
                <ThemeMode toggleTheme={toggleTheme} />
                <HowToPlay />
                <RemoveAgentsButton />
                <RefreshButton />
            </div>

            {/* <div className="controls-container visits-pageviews">
                <PrimalAnalytics/>
            </div> */}

            {/* <br></br> */}

        </div>
    );
}

function keyDownEvent(event) {
        var name = event.key;
        if (name === 'r') {
            // console.log("r IS PRESSED")
            restart(data.size);
            // alert('Primal has been restarted!');
        }
        if (name === 'c') {
            clearAgents();
            // alert('Primal has been cleared!');
        }
        if (name === 'p') {
            // console.log("p is pressed...")
            if (data.model_uploaded) {
                data.paused = !data.paused;
            } else {
                // alert('Upload Model first!');
            }
        }
        if (name === 'o') {
            data.mode = "obstacle";
            //alert('data.mode is now : ' + "obstacle");
        }
        if (name === 'g') {
            data.mode = "goal";
            //alert('data.mode is now : ' + "goal");
        }
        if (name === 'a') {
            data.mode = "agent";
            //alert('data.mode is now : ' + "agent");
        }

        // Remove arrow key because it takes in multiple inputs at once

        // if (name === "ArrowUp") {
        //     console.log('ARROW UP PRESSED')
        //     data.size += 1;
        //     restart(data.size)
        //     //alert('Up Arrow is now Pressed!');
        // }

        // if (name === "ArrowDown") {
        //     console.log('ARROW DOWN PRESSED')
        //     data.size -= 1;
        //     if (data.size <= 1) {
        //         data.size = 1;
        //     }
        //     restart(data.size)
        // }
        // //alert('Down Arrow is now Pressed!');

        if (name === 's') {
            data.ID += 1;
            //alert('Data has been saved!');
        }
}

function clickEvent(event) {
    let canvasElem = document.querySelector("canvas");
    let rect = canvasElem.getBoundingClientRect();
    let x = event.clientX - rect.left;
    let y = event.clientY - rect.top;
    let r = Math.floor((y / data.height) * data.size)
    let c = Math.floor((x / data.width) * data.size)
    //alert("Coordinate x: " + x + " Coordinate y: " + y + " r : " + r + " c : " + c);

    // console.log("data.goals :" + data.goals);

    if (r >= 0 && r <= (data.size - 1) && c >= 0 && c <= (data.size - 1)) {
        data.r = r;
        data.c = c;

        let rc_dataState = math.subset(data.state, math.index(r, c));  // data.state[r,c]
        let rc_dataGoals = math.subset(data.goals, math.index(r, c));  // data.goals[r,c]
        // console.log("Before rc_dataGoals : " + rc_dataGoals);
        // console.log("Before rc_dataState : " + rc_dataState);

        if (data.mode == "obstacle") {
            if (rc_dataState <= 0 && rc_dataGoals == 0) {
                //data.state[r,c]=-((data.state[r,c]+1)%2);
                data.state = math.subset(data.state, math.index(r, c), -((rc_dataState + 1) % 2));
                // console.log("this is clicked")

                ReactGA.event({
                    category: 'Grid Object',
                    action: 'Click',
                    label: 'Obstacle is Inserted'
                  });
            }
        }
        if (data.mode == "agent") {
            if (rc_dataState == 0 && rc_dataGoals == 0) {

                //data.state[r,c]=data.agent_counter
                data.state = math.subset(data.state, math.index(r, c), data.agent_counter);
                //data.goals[r,c]=data.agent_counter
                data.goals = math.subset(data.goals, math.index(r, c), data.agent_counter);
                //data.agent_positions = data.agent_positions.concat([r,c])
                if (data.agent_counter == 1) {
                    data.agent_positions = math.matrix([[r, c]]);
                } else {
                    data.agent_positions = math.concat(data.agent_positions, [[r, c]], 0);
                }
                data.blocking_confidences = data.blocking_confidences.concat(0)
                //data.blocking_confidences = math.concat(data.blocking_confidences, 0);

                //data.rnn_states.append(state_init) 
                if (data.agent_counter == 1) {
                    data.rnn_states = math.matrix([data.state_init]);
                    // console.log("data.rnn_states : " + data.rnn_states)
                    // console.log("math.matrix([data.state_init]) : " + math.matrix([data.state_init]))

                } else {
                    //     console.log("concatenating...")
                    //     console.log("data.rnn_states : " + data.rnn_states)
                    //     console.log("math.matrix([data.state_init]) : " + math.matrix([data.state_init]))
                    data.rnn_states = math.concat(data.rnn_states, math.matrix([data.state_init]), 0);
                }

                //data.agent_goals = data.agent_goals.concat([r,c])
                //data.agent_goals = math.concat(data.agenta_goals, (r,c))
                if (data.agent_counter == 1) {
                    data.agent_goals = math.matrix([[r, c]]);
                } else {
                    data.agent_goals = math.concat(data.agent_goals, [[r, c]], 0);
                }


                data.agent_counter += 1
                ReactGA.event({
                    category: 'Grid Object',
                    action: 'Click',
                    label: 'Agent is Inserted'
                  });

            }


        }

        if (data.mode == "goal") {
            // When clicked on agent, primed goal is changed to agent count number
            if (rc_dataState > 0 && data.primed_goal == 0) {
                data.primed_goal = rc_dataState;
            }
            // this is where you click on an empty box for the goal of the agent
            else if (rc_dataState != -1 && data.primed_goal > 0 && rc_dataGoals == 0) {
                removeGoal(data, data.primed_goal)
                //data.agent_goals[data.primed_goal-1]=(r,c)
                // Change agent_goals location
                data.agent_goals = math.subset(data.agent_goals, math.index(data.primed_goal - 1, 0), r);
                data.agent_goals = math.subset(data.agent_goals, math.index(data.primed_goal - 1, 1), c);
                //data.goals[r,c]=data.primed_goal
                data.goals = math.subset(data.goals, math.index(r, c), data.primed_goal);
                data.primed_goal = 0;
            }
            ReactGA.event({
                category: 'Grid Object',
                action: 'Click',
                label: 'Goal is Inserted'
              });
        }

        // console.log("After rc_dataGoals : " + math.subset(data.goals, math.index(r, c)));
        // console.log("After rc_dataState : " + math.subset(data.state, math.index(r, c)));
    }
}

function slider() {
    return <input type="range" min="1" max="100" value="50" />;
}

function printModelStatus() {
    let status;
    if (data.model_uploaded) {
        status = "Uploaded"
    } else {
        status = "Not Uploaded"
    }
    return status;
}

function printDataMode() {
    return data.mode;
}

function printDatas() {
    return "(" + data.r + "," + data.c
        + ")  data.state : " + data.state + "  data.agent_goals : " + data.agent_goals
        + "  data.agent_positions : " + data.agent_positions
        + "  data.primed_goal : " + data.primed_goal
        + " data.goals : " + data.goals
        + " data.blocking_confidences : " + data.blocking_confidences
        + " data.rnn_states : " + data.rnn_states
        + " data.state_init : " + data.state_init;
}

function printStatus() {
    let status = "Paused";
    if (!data.paused) {
        status = "Running";
    }
    return "Primal Status : " + status;
}

function removeGoal(data, agent) {
    for (let i = 0; i < data.size; i++) {
        for (let j = 0; j < data.size; j++) {
            let rc_dataGoals = math.subset(data.goals, math.index(i, j));  // data.goals[r,c]
            if (rc_dataGoals == agent) {
                data.goals = math.subset(data.goals, math.index(i, j), 0);
            }
        }
    }
}

export function restart(size) {
    data.map_loaded = false;
    data.paused = true;
    data.r = -1;
    data.c = -1;
    data.size = size;
    data.state = math.zeros(size, size);
    data.goals = math.zeros(size, size);
    // data.mode = "obstacle";
    data.agent_counter = 1;
    data.primed_goal = 0;
    data.ID = 0;
    data.blocking_confidences = [];
    data.agent_goals = math.matrix([[]]);
    data.agent_positions = math.matrix([[]]);
    data.rnn_states = math.matrix([[]]);
    data.state_init = math.matrix([math.zeros(1, 512), math.zeros(1, 512)]);
    data.GOALS = true;
    data.dirDict = { 0: [0, 0], 1: [0, 1], 2: [1, 0], 3: [0, -1], 4: [-1, 0], 5: [1, 1], 6: [1, -1], 7: [-1, -1], 8: [-1, 1] };
}

export function clearAll() {
    data.map_loaded = false;
    data.paused = true;
    data.r = -1;
    data.c = -1;
    // data.size = size;
    data.state = math.zeros(data.size, data.size);
    data.goals = math.zeros(data.size, data.size);
    // data.mode = "obstacle";
    data.agent_counter = 1;
    data.primed_goal = 0;
    data.ID = 0;
    data.blocking_confidences = [];
    data.agent_goals = math.matrix([[]]);
    data.agent_positions = math.matrix([[]]);
    data.rnn_states = math.matrix([[]]);
    data.state_init = math.matrix([math.zeros(1, 512), math.zeros(1, 512)]);
    data.GOALS = true;
    data.dirDict = { 0: [0, 0], 1: [0, 1], 2: [1, 0], 3: [0, -1], 4: [-1, 0], 5: [1, 1], 6: [1, -1], 7: [-1, -1], 8: [-1, 1] };
}



export function clearAgents() {
    data.paused = true;
    data.state = removeAgentsGoals(data);
    data.r = -1;
    data.c = -1;
    // data.size = 10;
    data.goals = math.zeros(data.size, data.size);
    // data.mode = "obstacle";
    data.agent_counter = 1;
    data.primed_goal = 0;
    data.ID = 0;
    data.blocking_confidences = [];
    data.agent_goals = math.matrix([[]]);
    data.agent_positions = math.matrix([[]]);
    data.rnn_states = math.matrix([[]]);
    data.state_init = math.matrix([math.zeros(1, 512), math.zeros(1, 512)]);
    data.GOALS = true;
    data.dirDict = { 0: [0, 0], 1: [0, 1], 2: [1, 0], 3: [0, -1], 4: [-1, 0], 5: [1, 1], 6: [1, -1], 7: [-1, -1], 8: [-1, 1] };
}





// For clear feature where Agents and Goals will be removed
function removeAgentsGoals(data) {
    let newDataState = math.zeros(data.size, data.size);
    for (let i = 0; i < data.size; i++) {
        for (let j = 0; j < data.size; j++) {
            let rc_dataState = math.subset(data.state, math.index(i, j));  // data.state[r,c]
            if (rc_dataState == -1) {
                newDataState = math.subset(newDataState, math.index(i, j), -1);
            }
        }
    }
    return newDataState;
}

